const translations = {
  triggers: 'Triggers',
  scheduledFor: 'Scheduled for',
  open: 'Open',
  sla: 'SLA',
  'filters.statusReasons': 'Status reasons',
  'filters.statusReason': 'Status reasons',
  'filters.place': 'Destination',
  'filters.semaphore': 'Traffic light',
  'filters.selectSemaphore': 'Traffic light selection',
  'filters.dates': 'Date range',
  'filters.createdBy': 'Created by',
  'filters.externalValue': 'External value',
  'filters.containsInName': 'Contains in name',
  anonymousResponse: 'Answered anonymously',
  selectUser: 'Select user',
  selectTag: 'Select tag',
  'dateOptions.overdue6Plus': 'Overdue 6+ days',
  'dateOptions.overdue2to5': 'Overdue 2-5 days',
  'dateOptions.overdue1': 'Overdue 1 day',
  'dateOptions.dueToday': 'Due today',
  'dateOptions.dueTomorrow': 'Due tomorrow',
  'dateOptions.due2to5': 'Due in 2-5 days',
  'dateOptions.due6to10': 'Due in 6-10 days',
  'dateOptions.due11to15': 'Due in 11-15 days',
  'dateOptions.due16to30': 'Due in 16-30 days',
  'dateOptions.due60Plus': 'Due in 60+ days',
  'slaValue.days': 'Days',
  'slaValue.hours': 'Hours',
  'slaValue.minutes': 'Minutes',
  'slaType.creationDate': 'Opening date',
  'slaType.schedulingDate': 'Scheduling date',
  'priority.critical': 'Critical',
  'priority.high': 'High',
  'priority.medium': 'Medium',
  'priority.low': 'Low',
  'cardPicker.selected': 'Selected',
  'cardPicker.selectOne': 'Select one',
  'types.root': 'First level activities',
  'types.actionPlan': 'Action plans',
  defaultLabel: 'Activities'
}

export default translations
